<template>
    <section class="sub-section">
        <v-container>
            <table class="board-list">
                <thead class="d-none d-lg-table-header">
                    <tr>
                        <th style="width:10%;" class="board-list__txt">NO.</th>
                        <th style="width:62.5%;" class="board-list__tit">제목</th>
                        <th style="width:12.5%;" class="board-list__txt">작성자</th>
                        <th style="width:12.5%;" class="board-list__txt">작성일</th>
                        <th style="width:12.5%;" class="board-list__txt">조회</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="about, index in abouts" :key="about._id" >
                        <td align="center" class="board-list__txt board-list__txt--first">
                            {{ index + 1 }}
                        </td>
                        <td align="center" class="board-list__tit">
                            <div class="ellip" @click="open(about.about.URL)" style="cursor: pointer">
                                {{ about.subject }}
                            </div>
                        </td>
                        <td align="center" class="board-list__txt board-list__txt--first">
                            {{ about.writer.name }}
                        </td>
                        <td align="center" class="board-list__txt">
                            {{ about.createdAt.toDate() }}
                        </td>
                        <td align="center" class="board-list__txt">
                            {{ about.viewCount }}
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="v-pagination-wrap">     
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div> 
        </v-container>  
    </section>
</template>

<script>
import api from "@/api"

export default {
    data() {
        return {
            abouts: [],

            filter: {
                code: "about",
                language: "ko",
            },

            page: 1,
            totalCount: 0,
            limit: 15
        }
    },
    async mounted() {
        await this.init()
    },
    computed: {
        pageCount() {
            return Math.ceil(this.totalCount / this.limit)
        },
        skip() {
            return (this.page - 1) * this.limit
        },
    },
    methods: {
        async init() {
            let { boards: abouts, summary } = await api.v1.boards.gets({
                headers: { skip: this.skip, limit: this.limit },
                params: { ...this.filter }
            })
            this.totalCount = summary.totalCount
            this.abouts = abouts
        },
        open(URL){
            if(URL) window.open(URL)
        }
    },
    watch: {
        async page() {
            await this.init()
        },
    }
}
</script>
